/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {getUserByToken, register} from '../core/_requests'
import {Link, Navigate} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
import {useAuth} from '../core/Auth'
import {useNavigate} from 'react-router-dom'
import authAPI from '../../../../api/authAPI'
import {toast} from 'react-toastify'

const initialValues = {
  firstname: '',
  phone: '',
  email: '',
  password: '',
  changepassword: '',
  acceptTerms: false,
}

const registrationSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Company name is required'),
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  phone: Yup.string().required('Phone Number is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
  changepassword: Yup.string()
    .required('Password confirmation is required')
    .when('password', {
      is: (val: string) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),
    }),
  acceptTerms: Yup.bool().required('You must accept the terms and conditions'),
})

export function Registration() {
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()
  const [showPassword, setShowPassword] = useState(false)
  const [showPassword2, setShowPassword2] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  const togglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2)
  }
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      let data = {
        company_name: values?.firstname,
        phone: values?.phone,
        email: values?.email,
        password: values?.password,
      }
      authAPI.registerRequest(data).then(
        (res: any) => {
          setLoading(false)
          if (res?.data?.success) {
            let dataNew = {
              unique_id: res?.data?.unique_id,
            }
            authAPI.registerRequestVerify(dataNew).then(
              (res: any) => {
                if (res?.data?.success) {
                  // navigate('/auth/account-verify/' + res?.data?.unique_id)
                  localStorage.setItem('tempUser', JSON.stringify(values))
                  toast.success(res?.data?.message, {theme: 'dark'})
                } else {
                  toast.error(res?.data?.message, {theme: 'dark'})
                }
              },
              (err: any) => {
                toast.error(err?.response?.data?.message, {theme: 'dark'})
              }
            )
            formik.resetForm()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          setLoading(false)
          toast.error(err?.response?.data?.message || 'Error Occured', {theme: 'dark'})
        }
      )
    },
  })
  const navigate = useNavigate()
  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])
  return (
    <div className='d-flex justify-content-center flex-wrap'>
      <img
        src={toAbsoluteUrl('/media/logos/asteric-white.png')}
        alt='logo'
        height={80}
        className='mb-5'
      />
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework  card p-10'
        noValidate
        id='kt_login_signup_form'
        onSubmit={formik.handleSubmit}
      >
        {formik.status && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{formik.status}</div>
          </div>
        )}

        {/* begin::Form group Firstname */}
        <div className='fv-row mb-4'>
          <label className='form-label fw-bolder text-dark fs-6'>Company Name</label>
          <input
            placeholder='Enter your company name '
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('firstname')}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': formik.touched.firstname && formik.errors.firstname,
              },
              {
                'is-valid': formik.touched.firstname && !formik.errors.firstname,
              }
            )}
          />
          {formik.touched.firstname && formik.errors.firstname && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.firstname}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}
        <div className='fv-row mb-4'>
          {/* begin::Form group Lastname */}
          <label className='form-label fw-bolder text-dark fs-6'>Official Email</label>
          <input
            placeholder='Enter official email adddress'
            type='email'
            autoComplete='off'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': formik.touched.email && formik.errors.email,
              },
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.email}</span>
              </div>
            </div>
          )}
          {/* end::Form group */}
        </div>

        {/* begin::Form group Email */}
        <div className='fv-row mb-4'>
          <label className='form-label fw-bolder text-dark fs-6'>Phone Number</label>
          <input
            placeholder='Enter a valid phone'
            type='number'
            autoComplete='off'
            {...formik.getFieldProps('phone')}
            className={clsx(
              'form-control bg-transparent',
              {'is-invalid': formik.touched.phone && formik.errors.phone},
              {
                'is-valid': formik.touched.phone && !formik.errors.phone,
              }
            )}
          />
          {formik.touched.phone && formik.errors.phone && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.phone}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group Password */}
        <div className='fv-row mb-4' data-kt-password-meter='true'>
          <div className='mb-1'>
            <label className='form-label fw-bolder text-dark fs-6'>Password</label>
            <div className='position-relative mb-3'>
              <div className='input-group'>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder='Enter password (min. of 8 characters)'
                  autoComplete='off'
                  {...formik.getFieldProps('password')}
                  className={clsx(
                    'form-control bg-transparent',
                    {
                      'is-invalid': formik.touched.password && formik.errors.password,
                    },
                    {
                      'is-valid': formik.touched.password && !formik.errors.password,
                    }
                  )}
                />
                <button
                  className='btn btn-outline-secondary'
                  type='button'
                  style={{background: '#e8f0fe'}}
                  onClick={togglePasswordVisibility}
                >
                  {!showPassword ? (
                    <i className='fa fa-eye'></i>
                  ) : (
                    <i className='fa fa-eye-slash'></i>
                  )}
                </button>
              </div>
              {formik.touched.password && formik.errors.password && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.password}</span>
                  </div>
                </div>
              )}
            </div>
            {/* begin::Meter */}
            <div
              className='d-flex align-items-center mb-3'
              data-kt-password-meter-control='highlight'
            >
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
            </div>
            {/* end::Meter */}
          </div>
          <div className='text-muted'>
            Use 8 or more characters with a mix of letters, numbers & symbols.
          </div>
        </div>
        {/* end::Form group */}

        {/* begin::Form group Confirm password */}
        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6'>Confirm Password</label>
          <div className='input-group'>
            <input
              type={showPassword2 ? 'text' : 'password'}
              placeholder='Password confirmation'
              autoComplete='off'
              {...formik.getFieldProps('changepassword')}
              className={clsx(
                'form-control bg-transparent',
                {
                  'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
                },
                {
                  'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
                }
              )}
            />
            <button
              className='btn btn-outline-secondary'
              type='button'
              style={{background: '#e8f0fe'}}
              onClick={togglePasswordVisibility2}
            >
              {!showPassword2 ? <i className='fa fa-eye'></i> : <i className='fa fa-eye-slash'></i>}
            </button>
          </div>
          {formik.touched.changepassword && formik.errors.changepassword && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.changepassword}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='fv-row mb-4 text-center fs-7'>
          {/* <label className='form-check form-check-inline' htmlFor='kt_login_toc_agree'>
            <input
              className='form-check-input'
              type='checkbox'
              id='kt_login_toc_agree'
              {...formik.getFieldProps('acceptTerms')}
            />
            <span>
              I Accept the{' '}
              <a
                href='https://keenthemes.com/metronic/?page=faq'
                target='_blank'
                className='ms-1 link-primary'
              >
                Terms
              </a>
              .
            </span>
          </label>
          {formik.touched.acceptTerms && formik.errors.acceptTerms && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.acceptTerms}</span>
              </div>
            </div>
          )} */}
          By Signing up, you agree to the{' '}
          <Link to='/auth/registration' style={{color: '#16C782'}}>
            Terms of Use
          </Link>
          , and{' '}
          <Link to='/auth/registration' style={{color: '#16C782'}}>
            Privacy Policy
          </Link>{' '}
          of Astrerics
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='text-center'>
          <button
            type='submit'
            // onClick={() => navigate('/auth/welcome')}
            id='kt_sign_up_submit'
            className='btn btn-lg btn-primary w-100 mb-5'
            style={{background: '#454743', borderRadius: 50}}
            // disabled={formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms}
          >
            {!loading && <span className='indicator-label'>Create Account</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          {/* <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_signup_form_cancel_button'
              className='btn btn-lg btn-light-primary w-100 mb-5'
            >
              Cancel
            </button>
          </Link> */}
        </div>
        <div className='text-black-500 text-center fw-semibold fs-6'>
          Don’t have an Asterics account?{' '}
          <Link to='/auth/login' style={{color: '#16C782', textDecoration: 'underline'}}>
            Sign in
          </Link>
        </div>
        {/* end::Form group */}
      </form>
    </div>
  )
}
